/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
let lastScrollY = window.scrollY;
const header = document.getElementById('header');

window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    
    // At top of page - always show
    if (currentScrollY === 0) {
        header.classList.remove('hidden-header');
        header.classList.add('visible-header');
        return;
    }
    
    // Scrolling down - hide header
    if (currentScrollY > lastScrollY && currentScrollY > 100) {
        header.classList.remove('visible-header');
        header.classList.add('hidden-header');
    } 
    // Scrolling up - show header
    else if (currentScrollY < lastScrollY) {
        header.classList.remove('hidden-header');
        header.classList.add('visible-header');
    }
    
    lastScrollY = currentScrollY;
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
